import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Client-side "seen" state for storefront stories (there is no server tracking —
// display only, mirroring the mobile app). Slug-scoped and capped so one store's
// history can't grow unbounded or leak into another store on the same browser.

const CAP = 500;

interface StoriesSeenState {
  slug: string;
  seen: string[];
  markSeen: (slug: string, id: string) => void;
}

export const useStoriesSeen = create<StoriesSeenState>()(
  persist(
    (set, get) => ({
      slug: '',
      seen: [],
      markSeen: (slug, id) => {
        const st = get();
        const base = st.slug === slug ? st.seen : [];
        if (base.includes(id)) { if (st.slug !== slug) set({ slug, seen: base }); return; }
        set({ slug, seen: [...base, id].slice(-CAP) });
      },
    }),
    { name: 'erp-store-stories-seen' },
  ),
);

export function isSeen(state: Pick<StoriesSeenState, 'slug' | 'seen'>, slug: string, id: string): boolean {
  return state.slug === slug && state.seen.includes(id);
}
